import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useStats() {
  const query = useQuery({
    queryKey: ['stats'],
    queryFn: () => api.getStats(),
  });

  return {
    stats: query.data ?? null,
    loading: query.isLoading,
    error: query.error,
  };
}
